import type { SVGProps } from 'react';
const SvgIconArrowDiag = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M5.25 4C4.56 4 4 4.56 4 5.25v5.5c0 .69.56 1.25 1.25 1.25h5.5c.69 0 1.25-.56 1.25-1.25v-.5a.75.75 0 0 1 1.5 0v.5a2.75 2.75 0 0 1-2.75 2.75h-5.5a2.75 2.75 0 0 1-2.75-2.75v-5.5A2.75 2.75 0 0 1 5.25 2.5h.5a.75.75 0 0 1 0 1.5z"
    />
    <path
      fill="currentColor"
      d="M12.75 8a.75.75 0 0 1-.75-.75V5.06L8.53 8.53a.75.75 0 0 1-1.06-1.06L10.94 4H8.75a.75.75 0 0 1 0-1.5h3.5c.69 0 1.25.56 1.25 1.25v3.5a.75.75 0 0 1-.75.75"
    />
  </svg>
);
export default SvgIconArrowDiag;
